module.exports = __webpack_public_path__ + "img/zs3.43506468.png";